import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

const pageTitles = {
  '/': 'Gosterge Paneli',
  '/sites': 'Site Yoneticisi',
  '/sites/new': 'Yeni Site Olustur',
  '/sites/bulk': 'Toplu Site Olustur',
  '/seo': 'SEO Paneli',
  '/scheduler': 'Icerik Zamanlayici',
  '/review': 'Inceleme Kuyrugu',
  '/deploy': 'Deploy Yonetimi',
  '/monitoring': 'Izleme & Alertler',
  '/analytics': 'Analitik Paneli',
  '/revenue': 'Gelir Istihbarati',
  '/launch': 'Canliya Alma Kontrol Listesi',
  '/servers': 'Sunucu Yonetimi',
};

export function Topbar() {
  const location = useLocation();
  const path = location.pathname;
  const [env, setEnv] = useState('');
  
  useEffect(() => {
    // Detect environment from hostname
    const host = window.location.hostname;
    if (host.includes('preview.emergentagent.com')) {
      setEnv('PREVIEW');
    } else if (host === 'localhost' || host === '127.0.0.1') {
      setEnv('LOCAL');
    } else {
      setEnv('PRODUCTION');
    }
  }, []);
  
  let title = pageTitles[path];
  if (!title) {
    if (path.startsWith('/sites/') && path.includes('/detail')) {
      title = 'Site Detayi';
    } else if (path.startsWith('/preview/')) {
      title = 'Onizleme';
    } else {
      title = 'TrafficOS';
    }
  }

  return (
    <header className="flex items-center justify-between px-4 sm:px-6 lg:px-8 py-4 border-b border-border/50 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center gap-4 lg:ml-0 ml-12">
        <h2 className="text-lg font-semibold tracking-tight font-['Space_Grotesk']">
          {title}
        </h2>
        {env && (
          <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${
            env === 'PRODUCTION' 
              ? 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30' 
              : env === 'PREVIEW' 
                ? 'bg-amber-500/15 text-amber-400 border border-amber-500/30'
                : 'bg-blue-500/15 text-blue-400 border border-blue-500/30'
          }`} data-testid="env-badge">
            {env}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <Link to="/sites/new">
          <Button 
            data-testid="topbar-create-site-button"
            className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--primary))]/90 gap-2 press-active"
            size="sm"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">Yeni Site</span>
          </Button>
        </Link>
      </div>
    </header>
  );
}
